module.exports = __webpack_public_path__ + "media/img/illustrations/icons/modal-close-35c384f4a48628caf8b5dcd3adb8dae3.svg";